import { render, staticRenderFns } from "./DisclosureBlock.vue?vue&type=template&id=6faef59e&"
import script from "./DisclosureBlock.vue?vue&type=script&lang=js&"
export * from "./DisclosureBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports